// eslint-disable-next-line import/prefer-default-export
export { default as secondaryStyles } from './secondary';
export { default as primaryStyles } from './primary';
